// Module
var code = `<template>
  <require from="./customer-totals-widget.scss"></require>
  <global-progress if.bind="loading"></global-progress>
  <div if.bind="!loading && !error" class="customer-totals-widget customer-totals-widget-\${id}">

    <!-- beautify ignore:start -->
    <style>
      .customer-totals-widget-\${id} .value {
        font-family: \${font || 'var(--dyn-default-font-family)'};
        font-size: \${fontSize ? fontSize + 'px' : 'var(--dyn-default-font-size)'};
        color: \${color | widgetTemplateColor:isInDashboard} !important;
      }

      .customer-totals-widget-\${id} .caption {
        font-family: \${captionFont ? captionFont : 'var(--dyn-default-caption-font-family)'};
        font-size: \${captionFontSize ? captionFontSize + 'px' : 'var(--dyn-default-caption-font-size)'};
        color: \${captionColor | widgetTemplateColor:isInDashboard} !important;
      }
    </style>
    <!-- beautify ignore:end -->

    <div if.bind="showValueLM">
      <div class="value">\${totalsLM.estimatedValue | numericFormatter:'0.0a'}</div>
      <div class="caption">Portfolio value LM</div>
    </div>
    <div if.bind="showValueYTD">
      <div class="value">\${totals.estimatedValue | numericFormatter:'0.0a'}</div>
      <div class="caption">Portfolio value YTD</div>
    </div>
    <div if.bind="showNav">
      <div class="value">\${totals.netAssetValueAdjusted | numericFormatter:'0.0a'}</div>
      <div class="caption">NAV</div>
    </div>
    <div if.bind="showNavPerShare">
      <div class="value">\${totals.navPerShare | numericFormatter:'0.0a'}
      </div>
      <div class="caption">NAV per share</div>
    </div>
    <div if.bind="showProfitLM">
      <div class="value">\${totalsLM.profitLossYearToDate | numericFormatter:'0.0a'}</div>
      <div class="caption">Profit LM</div>
    </div>
    <div if.bind="showProfitYTD">
      <div class="value">\${totals.profitLossYearToDate | numericFormatter:'0.0a'}</div>
      <div class="caption">Profit YTD</div>
    </div>
    <div if.bind="showNavChangeLM">
      <div class="value">\${navChangeLM | numericFormatter:'0.0a'}</div>
      <div class="caption">NAV Δ LM</div>
    </div>
    <div if.bind="showNavChangeYTD">
      <div class="value">\${navChangeYTD | numericFormatter:'0.0a'}</div>
      <div class="caption">NAV Δ YTD</div>
    </div>
    <div if.bind="showNavChangeYTDLM">
      <div class="value">\${navChangeYTDLM | numericFormatter:'0.0a'}</div>
      <div class="caption">NAV Δ YTD LM</div>
    </div>
    <div if.bind="showOsebxChangeLM">
      <div class="value">\${osebxChangeLM | numericFormatter:'0.0a'}</div>
      <div class="caption">OSEBX Δ LM</div>
    </div>
    <div if.bind="showOsebxChangeYTD">
      <div class="value">\${osebxChangeYTD | numericFormatter:'0.0a'}</div>
      <div class="caption">OSEBX Δ YTD</div>
    </div>
    <div if.bind="showOsebxChangeYTDLM">
      <div class="value">\${osebxChangeYTDLM | numericFormatter:'0.0a'}</div>
      <div class="caption">OSEBX Δ YTD LM</div>
    </div>
  </div>
  <message if.bind="error" icon="error" colour="mdc-theme--error" class="customer-totals-widget__error">
    \${error.message}</message>
  <div if.bind="noGL" class="customer-totals-widget__no-gl-warning warning">
    Warning: No GL data available for this period
  </div>
</template>
`;
// Exports
export default code;